import { IRoutePoint } from "./types"

export const ClearRoutePoints = (items:IRoutePoint[]):IRoutePoint[] => {
  return items.filter((i)=>!!i.poi || (!!i.street && !!i.house))
}